import {Component, OnInit, inject} from '@angular/core';
import {I18nService} from '../../_services/gui/i18n.service';
import {User} from '../../_data/admin/user';
import {UsersService} from '../../_services/data/users.service';
import {BehaviorSubject} from 'rxjs';
import {GuiPermissionsService} from '../../_services/gui/gui-permissions.service';
import {UserListComponent} from './user-list/user-list.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-user-admin',
    templateUrl: './user-admin.component.html',
    styleUrls: ['./user-admin.component.scss'],
    imports: [UserListComponent, TranslateModule]
})
export class UserAdminComponent implements OnInit {
  usersService = inject(UsersService);
  guiPermissionsService = inject(GuiPermissionsService);

  usersSubject: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);

  private i18nService = inject(I18nService);

  ngOnInit() {
    this.i18nService.setTitle('title.admin.users.list');
  }

  searchForUser(val: string) {
    this.usersService.searchForUsers(val).subscribe(users => this.usersSubject.next(users));
  }
}
